<kodit-table [tableConfig]="tableConfig" [paginatedData]="paginatedData"> </kodit-table>

